import { useCallback } from 'react';
import mergeDeepRight from '../node_modules/.pnpm/ramda@0.29.0/node_modules/ramda/es/mergeDeepRight.mjs';

var useToken = function useToken(options, token) {
  return useCallback(function () {
    var density = options.density;
    if (density === 'compact') {
      return mergeDeepRight(token, token.modes.compact);
    }
    return token;
  }, [options, token]);
};

export { useToken };
